import {SecureService} from "@/services/superclasses/secure-service";
import {Exchange} from "@/interfaces/exchange";

const api = window.contextPath + '/rest/exchanges';

export class ExchangeSecureService extends SecureService {

    public loadAll = async (type: Array<number>): Promise<Exchange[]> => {
        return this.data(await this.get<Exchange[]>(api,
            {
                params: {
                    type
                }
            }))
    }
}

export const exchangeSecureService = new ExchangeSecureService()